import * as _ from "lodash";
import {BaseEditSubView, BaseEditSubViewOptions} from "./_BaseEditView";
import {EditReportsNavView} from "./EditReportsNavView";
import * as $ from "jquery";
import {TimezoneCollection} from "../../../collections/Timezones";
import * as moment from "moment-timezone";
import * as Backbone from "backbone";
import {Utils} from "../../../common/utils";
import "select2"

require('bootstrap-datetimepicker');

export class EditSettingsView extends BaseEditSubView {

    private template = _.template(require('../../../templates/reports/editReports/editSettings.html'));
    private navView: EditReportsNavView;
    private report = this.options.report;

    constructor(options: BaseEditSubViewOptions) {
        super(<any> _.extend(options, {
            events: {
                'click .save-settings.btn-success': 'handleSaveSettings',
                'change .recipients': 'handleAddRecipient',
                'click .delete-recipient': 'handleDeleteRecipient',
                'change .add-report-interval': 'handleChangeReportInterval',
                'change .timezone select': 'handleChangeReportTimezone',
                'input .add-report-name': 'handleNameInput'
            }
        }));

        this.navView = new EditReportsNavView(options);
    }

    render () {
        var dateTimePickerFormat = 'LT';
        this.$el.html(this.template({
            reportsCollection: this.options.reportsCollection,
            userCollection: this.options.userCollection,
            timezones: new TimezoneCollection(),
            report: this.report,
            orgId: this.options.orgId,
            reportTimezone: this.report.get('timezone'),
            dateTimePickerFormat,
            moment: moment,
            Utils: Utils
        }));

        // Render the nav bar
        this.renderSubViews();
        this.handleChangeReportInterval();

        // initialize recipient select2 and timepicker
        this.initializeSelect2();
        (<any>this.$('.data-range-time .date')).datetimepicker({
            format: dateTimePickerFormat
        });

        return this;
    }

    renderSubViews () {
        // Render the nav bar
        this.$('.nav-container').empty().append(this.navView.render().el);
    }

    private getName() {
        return String(this.$('.add-report-name').val()).trim();
    }

    private handleNameInput() {
        this.$('.save-settings').prop('disabled', !this.getName().length);
    }

    private handleSaveSettings(e: JQuery.UIEventBase) {
        e.preventDefault();

        this.$('.settings-nav-buttons').addClass('hidden');
        this.$('.settings-save-spinner').removeClass('hidden');

        var reportId = this.options.report.get('id');
        var interval = Number(this.$('.add-report-interval').val());

        $.ajax({
            type: "PUT",
            url: this.options.reportsCollection.url() + '/' + this.options.orgId + '/' + reportId,
            data: JSON.stringify(_.extend({
                name: this.getName(),
                interval: interval,
                recipient: this.getRecipientsFromUI().join((',')),
                timezone: this.$('.timezone select').val()
            }, this.getOffsetsFromUI())),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            complete: (res) => {
                // Re-add this timeout if the spinner doesn't show long enough
                // setTimeout(() => {
                    this.refetchCollectionsAndShow(reportId, 'settings');
                // }, 500);
            }
        });
    }

    private handleAddRecipient() {
        var recipientsList = this.$('ul.recipients-list');
        var newRecipient= <string>this.$('.recipients option:selected').val();
        var isValidEmail = Utils.isValidEmail(newRecipient);

        // Add valid recipient email to list
        if (isValidEmail) {
            recipientsList.append('<li class="list-group-item">' + newRecipient + '<span class="clickable delete-recipient pull-right"><i class="fa fa-trash"></i></span></li>');
        }
    }

    private handleDeleteRecipient(e: JQuery.UIEventBase) {
        // Remove selected recipient email from list
        this.$(e.currentTarget).parents('li').remove();
    }

    private getRecipientsFromUI() {
        var newRecipients = [];
        var lis = this.$('.recipient-form li').get();

        _.each(lis, (li) => {
            var trimmedText = $(li).text().trim();
            if (!_.includes(newRecipients, trimmedText)) newRecipients.push(trimmedText);
        });

        return newRecipients;
    }

    private getOffsetsFromUI() {
        var offsets = {offset_months: null, offset_days: null, offset_seconds: null};
        var reportInterval = Number(this.$('.add-report-interval').val());
        if (reportInterval == 0) return;

        var d = this.$('.data-range-time .date').data("DateTimePicker").viewDate();
        offsets.offset_seconds = String(d.hour() * 3600 + d.minute() * 60 + d.second());

        if (reportInterval === 2) { // Weekly
            offsets.offset_days = String(this.$('.data-range-weekly select').val());
        } else if (reportInterval > 2) { // Monthly & Yearly
            offsets.offset_days = String(this.$('.data-range-monthly select').val());
        }

        if (reportInterval === 4) { // Yearly
            offsets.offset_months = String(this.$('.data-range-yearly select').val());
        }

        return offsets;
    }

    refetchCollectionsAndShow(reportId, view) {
        $.when(this.options.reportsCollection.fetch()).done(() => {
            Backbone.history.loadUrl();

            window['App'].Bus.trigger('navigation:update');
        });
    }

    private handleChangeReportInterval() {
        var reportInterval = Number(this.$('.add-report-interval').val());

        this.$('.data-range-custom-wrapper').toggleClass('hidden', reportInterval === 0);
        this.$('.interval-timezone').toggleClass('hidden', reportInterval === 0);
        this.$('.data-range-yearly').toggleClass('hidden', reportInterval < 4);
        this.$('.data-range-monthly').toggleClass('hidden', reportInterval < 3);
        this.$('.data-range-weekly').toggleClass('hidden', reportInterval !== 2);
        this.$('.data-range-monthly').toggleClass('col-sm-offset-3 hspace-20', reportInterval === 4);
        this.$('.data-range-time').toggleClass('hspace-20', reportInterval === 4);
    }

    private initializeSelect2() {
        this.$('.add-report-interval').select2(Utils.Select2.defaultOptions);
        this.$('.data-range-yearly select').select2(Utils.Select2.defaultOptions);
        this.$('.data-range-monthly select').select2(Utils.Select2.defaultOptions);
        this.$('.data-range-weekly select').select2(Utils.Select2.defaultOptions);
        this.$('.timezone select').select2(_.extend({}, Utils.Select2.defaultOptions));

        // Allow this neato dropdown where you can define your own items
        this.$('.form-control.recipients').select2(_.extend({
            tags: true,
            createTag: (params) => {
                if(!params.term.length) {
                    return {
                        id: 'New Recipient',
                        text: 'Start typing to add a new recipient'
                    }
                } else {
                    return {
                        id: params.term,
                        text: params.term
                    }
                }
            }
        }, Utils.Select2.defaultOptions))
    }

    remove() {
        // Clean up nav
        this.navView.remove();
        // Also do what the super view would normally do
        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/reports/editReports/EditSettingsView.ts